import axios from 'axios';
import { SERVER_URL } from '../../helpers/Config';
import { getToken, getPreviewToken } from '../../helpers/Token';

export const makeFetch = async (
  url,
  method,
  body = {},
  headers = {},
  baseURL = SERVER_URL,
  extras = {}
) => {
  const tokenPreview = await getPreviewToken();
  const tokenLogin = await getToken();
  let token = tokenPreview ? tokenPreview : tokenLogin;
  switch (method.toUpperCase()) {
    case 'GET':
    case 'HEAD':
      return axios({
        url,
        method,
        headers: { Authorization: token, ...headers },
        params: body,
        baseURL,
        ...extras,
      });
    case 'POST':
    case 'PUT':
    case 'DELETE':
      return axios({
        url,
        method,
        headers: { Authorization: token, ...headers },
        data: body,
        baseURL,
        ...extras,
      });
    default:
      throw new Error('Unknown method in fetcher, ', method);
  }
};
